module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-view has-header"
  }, [_c('user-bar'), _vm._v(" "), _c('group', {
    attrs: {
      "title": "租房找室友",
      "items": _vm.group_a
    }
  }, [_c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "#"
    },
    slot: "more"
  }, [_vm._v("更多相关小组")])]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "来聊五块钱",
      "items": _vm.group_b
    }
  }, [_c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "#"
    },
    slot: "more"
  }, [_vm._v("来聊五块钱")])]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "买买买",
      "items": _vm.group_c
    }
  }, [_c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "#"
    },
    slot: "more"
  }, [_vm._v("更多相关小组")])]), _vm._v(" "), _c('download-app')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45f6a39c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/GroupView.vue
// module id = 195
// module chunks = 0